export default __webpack_public_path__ + "static/media/project1-iphone.4374987e.png";